export default __webpack_public_path__ + "static/media/icon_c.9ada05d5.svg";